import React from "react";
import { generatePath, useMatch, useParams } from "react-router";
import { LinearProgress, List, ListItem } from "@mui/material";

import { Routes } from "#/config";
import { PageContainer } from "#pages/PageContainer";
import { useAppDispatch, useAppSelector } from "#store";
import { Link } from "#common/Link";
import { H1, H2, P } from "#common/headings";
import { selectOperatorInvocationRawById } from "#selectors";
import { fetchOperatorInvocationFromServer } from "#store/operatorInvocations/operatorInvocationActions";
import { IoStateComponentHoc } from "#common/io/IoStateComponentHOC";
import LinkButton from "#common/LinkButton";
import { OperatorInvocation } from "#/services/pilotService/types";

type OperatorInvocationPageRouteMatchProps = {
    id: string;
};
const OperatorInvocationDetails = (operatorInvocation: OperatorInvocation) => {
    return (
        <PageContainer>
            <H1>Operator Invocation {operatorInvocation.id}</H1>
            <P>Operation is {operatorInvocation.status}</P>
            <Link
                to={generatePath(Routes.action.path, {
                    id: String(operatorInvocation.action),
                })}
            >
                Result of action {operatorInvocation.action}.
            </Link>
            <H2>
                {operatorInvocation.interpretations.length} interpretations
                materialized:
            </H2>
            {operatorInvocation.rawInterpretationCount >
            operatorInvocation.interpretations.length ? (
                <LinearProgress
                    value={
                        (100 * operatorInvocation.interpretations.length) /
                        operatorInvocation.rawInterpretationCount
                    }
                />
            ) : null}
            <List>
                {operatorInvocation.interpretations.map(x => (
                    <ListItem key={x}>
                        <LinkButton
                            to={generatePath(Routes.interpretation.path, {
                                id: String(x),
                            })}
                        >
                            Interpretation {x}
                        </LinkButton>
                    </ListItem>
                ))}
            </List>
        </PageContainer>
    );
};

const IoStateOperatorInvocationDetails =
    IoStateComponentHoc<OperatorInvocation>(OperatorInvocationDetails);

export const OperatorInvocationPage = () => {
    let { id } = useParams();

    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(fetchOperatorInvocationFromServer(Number(id)));
    }, [id]);

    const operatorInvocation = useAppSelector(state =>
        selectOperatorInvocationRawById(state, Number(id))
    );

    return (
        <PageContainer>
            <IoStateOperatorInvocationDetails iostate={operatorInvocation} />
        </PageContainer>
    );
};
